import React from 'react';

export default function Component(props) {

  const { question, answersList, surveyLanguageCode, handleCheckInput, surveyScreenData } = props;

  // console.log("question optionsList--->", question)

  return (
    <>
      <div className="overflow-y-auto">
        <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-2">

          {question?.optionsList?.length > 0 &&
            question.optionsList.map((option, optionindex) => {

              // ----- CHECK IF OPTION IS SELECTED -----
              const isChecked =
                answersList?.length > 0 &&
                answersList.findIndex(item => item.questionId === question.id) !== -1 &&
                answersList[
                  answersList.findIndex(item => item.questionId === question.id)
                ].multiAnswer.some(prev => prev.optionId === option.id);

              // ----- GET OPTION TEXT (MULTI-LANGUAGE) -----
              const optionText =
                surveyLanguageCode !== ""
                  ? (question?.transl?.[surveyLanguageCode]?.optionsList?.[option.id] ||
                    option.name)
                  : option.name;

              const textColor = isChecked
                ? surveyScreenData?.optionTextActiveColor || "#FFFFFF"
                : surveyScreenData?.optionTextColor || "#FFFFFF";

              const bgColor = isChecked
                ? surveyScreenData?.optionBgActiveColor || "#5ACC66"
                : surveyScreenData?.optionBgColor || "#3B92D4";

              const borderColor = isChecked
                ? surveyScreenData?.optionBorderActiveColor || "#5ACC66"
                : surveyScreenData?.optionBorderColor || "#3B92D4";


              return (
                <label
                  key={optionindex}
                  className="flex flex-row items-center gap-2 cursor-pointer p-2 rounded-md border"
                  style={{ color: textColor, background: bgColor, borderColor: borderColor }}
                >
                  {/* ------ CHECKBOX ------- */}
                  <input
                    type="checkbox"
                    style={{ background: bgColor }}
                    className=" w-4 h-4 custom-check flex items-center justify-center"
                    checked={isChecked}
                    onClick={() => handleCheckInput(optionindex, question, option)}
                    onChange={() => { }}
                  />

                  {/* ------ OPTION TEXT ------- */}
                  <span className="text-sm text-left font-medium">
                    {optionText.toString()}
                  </span>
                </label>
              );
            })
          }

        </div>
      </div>
    </>
  );
}